/*
 * Jira Ticket:
 * Created Date: Fri, 21st Jan 2022, 17:19:27 pm
 * Author: Rafiul Ansari
 * Email: raf.ansari@thedistance.co.uk
 * Copyright (c) 2022 The Distance
 */

import { fetchStart, fetchEnd } from 'react-admin';
import * as R from 'ramda';

export default function getUploadInfo(
  key,
  { dataProvider, dispatch, setUploadInfo }
) {
  return () => {
    let isSubscribed = true;
    dispatch(fetchStart());
    dataProvider('GET_ONE', 'Configuration', { id: key })
      .then(result => {
        if (isSubscribed) {
          const configValue = R.path(['data', 'value'], result);
          setUploadInfo(configValue);
        }
      })
      .catch(() => {})
      .finally(() => {
        dispatch(fetchEnd());
      });

    return () => (isSubscribed = false);
  };
}
